module.exports = __webpack_public_path__ + "static/media/vihara.78751ce7.svg";